import React from "react";
import Button from "react-bootstrap/esm/Button";
import { useI18n } from "../../lib/i18n/i18n_provider";
import { ChevronLeftIcon, ChevronRightIcon } from "./icons";

export function BackButton(props: { label?: string; onPress: () => void }) {
  const { fbt, locale } = useI18n();
  return (
    <Button
      variant="link"
      onClick={props.onPress}
      className="text-decoration-none p-0 d-none d-md-block fw-normal"
    >
      {locale.direction === "ltr" && <ChevronLeftIcon />}
      {locale.direction === "rtl" && <ChevronRightIcon />}{" "}
      {props.label ?? fbt("Back")}
    </Button>
  );
}
